import { Pipe, PipeTransform } from '@angular/core';
import { ChipColorClass, TilledChipConfig } from 'app/shared/tilled-chip/tilled-chip.component';
import { AccountDocument, InternalAccount } from '../../../../projects/tilled-api-client/src';

@Pipe({
  name: 'informationRequestedPipe',
  standalone: true,
})
export class DocumentRequestDaysToRespondPipe implements PipeTransform {
  constructor() {}

  /**
   *
   * @param account InternalAccount object
   * @param solid Whether or not the chip should be solid in color or not
   * @returns
   */
  transform(account: InternalAccount): TilledChipConfig {
    let chipConfig: TilledChipConfig = {
      color: null,
      text: null,
      toolTip: null,
    };

    let daysToRespond: number = null;
    const requestedDocuments = account.document_requests.filter(
      (doc) => doc.status === AccountDocument.StatusEnum.REQUESTED,
    );
    const submittedDocuments = account.document_requests.filter(
      (doc) => doc.status === AccountDocument.StatusEnum.REQUESTED,
    );

    // Find requested Documents
    if (requestedDocuments.length > 0) {
      const daysToRespondOptions = requestedDocuments.map((dr) => Date.parse(dr.respond_by));
      if (daysToRespondOptions.length > 0) {
        const today = new Date();
        const minDateToRespond = Math.min(...daysToRespondOptions);
        daysToRespond = Math.round((minDateToRespond - today.getTime()) / (1000 * 60 * 60 * 24));
        if (daysToRespond >= 10) {
          chipConfig.text = `${daysToRespond} DAYS TO RESPOND`;
          chipConfig.color = ChipColorClass.OPAQUE_YELLOW;
        } else if (daysToRespond < 10 && daysToRespond > 0) {
          chipConfig.text = `${daysToRespond} DAYS TO RESPOND`;
          chipConfig.color = ChipColorClass.OPAQUE_RED;
        } else if (daysToRespond === 0) {
          chipConfig.text = `TODAY`;
          chipConfig.color = ChipColorClass.OPAQUE_RED;
        } else {
          chipConfig.text = `PAST DUE`;
          chipConfig.color = ChipColorClass.OPAQUE_RED;
        }
      }
    }
    // ELSE Find submitted Documents
    if (requestedDocuments.length === 0 && submittedDocuments.length > 0) {
      chipConfig.text = 'NO ACTION NEEDED';
      chipConfig.color = ChipColorClass.OPAQUE_GREEN;
    }

    return chipConfig;
  }
}
